import cloudFunctionApi from '../../../../cloudfunctions';
import firebaseApi from '../../../../firebase/firebaseApi';
import {
	useUserAuthContext,
	useUserDetailsContext,
} from '../../../../providers/UserProvider';
import { LoadingDots } from '../../../Management/subcomponents/LoadingDots';
import { EmployeesTab } from './EmployeesTab';

export const EmployeesWrapper = (): JSX.Element => {
	const userDetails = useUserDetailsContext();
	const user = useUserAuthContext();

	return userDetails === null || user === null ? (
		<LoadingDots />
	) : (
		<EmployeesTab
			firebaseApi={firebaseApi}
			cloudFunctionApi={cloudFunctionApi}
			userDetails={userDetails}
			user={user}
		/>
	);
};
